// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1xTl2","col":"CardReaderDesc_col__n4t17","label":"CardReaderDesc_label__1SYng"};